<template>
  <v-card>
    <v-flex xs12 v-if="messages">
      <message :messages="messages"></message>
    </v-flex>
    <v-card-title>
      <v-flex xs6>
        <div class="headline">Overriding Agent</div>
      </v-flex>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :footer-props="{'items-per-page-options': itemsPerPage }"
      :options.sync="pagination"
      item-key="index"
      :loading="loading"
      :no-data-text="noDataText"
      :custom-filter="customSearch"
    >
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span v-on="on">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template v-slot:item="row">
        <tr>
          <td class="text-xs-left">{{ row.item.seqNo }}</td>
          <td class="text-xs-left">{{ row.item.ovrInter }}</td>
          <td class="text-xs-left">{{ formatBoolean(row.item.protect) }}</td>
          <td class="text-xs-left">{{ row.item.commGn }}</td>
          <td class="text-xs-left">{{ row.item.commPct }}</td>
          <td class="text-xs-left">{{ formatBoolean(row.item.void_) }}</td>
          <td class="table-action-header">
            <table-action :rowData="row" review @review="doReview" query @query="doQuery" remove @remove="doPromptRemove(row.item)"></table-action>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-checkbox :label="labels.voidTransaction" v-model="voidTransaction" v-on:change="doInit()"></v-checkbox>
    <v-btn color="primary" dark class="mb-2" @click="doNew">New Overriding Agent<v-icon>mdi-plus</v-icon></v-btn>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Overriding Agent?
      <div class="title">{{ deleteOvrInter }}</div>
    </confirm>
  </v-card>
</template>
<script>
import * as TableConst from '@/mixins/table'
import { mapGetters } from 'vuex'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDateTime3 } from '@/utils/date'

export default {
  data() {
    return {
      headers: [
        { text: 'Sequence', value: 'seqNo' },
        { text: 'Overriding Agent', value: 'ovrInter' },
        { text: 'Protect', value: 'protect' },
        { text: 'Gross/Net', value: 'commGN' },
        { text: 'Rate%', value: 'commPct' },
        { text: 'Void', value: 'void_' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortBy: 'ovrInter'
      },
      labels: {
        voidTransaction: 'Include void transactions'
      },
      promptRemove: false,
      voidTransaction: false,
      deleteOvrInter: '',
      menu: []
    }
  },
  computed: {
    ...mapGetters(['checkAccess'])
  },
  watch: {
    fetchOverridingAgt: function (value) {
      if (value !== false) {
        if (this.ids.commissionNo !== 'new') {
          this.fetchData(this.ids.commissionNo)
        }
      }
    }
  },
  methods: {
    async fetchData(commissionNo) {
      const apiURI = this.$store.state.adminInter.intermediary.menu.getCommission
      if (apiURI) {
        try {
          const expand = {
            inter: this.ids.inter,
            effDate: formatDisplayDateTime3(this.ids.effDate),
            polType: this.ids.polType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.menu = extractMenu(result.data._links)
          } else {
            this.errorMessage('Fail to load Data from server. Please try to refresh page')
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.doInit()
    },
    async doInit() {
      if (!this.voidTransaction) {
        const apiURI = this.menu.ovrAgtList
        if (apiURI) {
          const expand = {
            inter: this.ids.inter,
            effDate: formatDisplayDateTime3(this.ids.effDate),
            polType: this.ids.polType
            // commissionNo: commissionNo
          }
          try {
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.items = []
              data.map((ovrAgt) => {
                const convertOvrAgt = {
                  seqNo: ovrAgt.seqNo,
                  inter: ovrAgt.inter,
                  ovrInter: ovrAgt.ovrInter,
                  protect: ovrAgt.protect,
                  commGn: ovrAgt.commGn,
                  commPct: ovrAgt.commPct,
                  commType: ovrAgt.commType,
                  void_: ovrAgt.void_
                }
                this.items.push(convertOvrAgt)
              })
              this.loading = false
            } else {
              this.loading = false
              this.items = []
            }
          } catch (error) {
            const { data } = error
            if (data) {
              this.message(data)
              this.fieldMessage(data)
              this.loading = false
            }
          }
        } else {
          this.loading = false
          this.errorMessage('The request failed because it is trying to execute an invalid API url. - Overriding Agent List')
          this.items = []
        }
      } else {
        const apiURI = this.menu.ovrAgtList2
        if (apiURI) {
          const expand = {
            inter: this.ids.inter,
            effDate: formatDisplayDateTime3(this.ids.effDate),
            polType: this.ids.polType
            // commissionNo: commissionNo
          }
          try {
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.items = []
              data.map((ovrAgt) => {
                const convertOvrAgt = {
                  seqNo: ovrAgt.seqNo,
                  inter: ovrAgt.inter,
                  ovrInter: ovrAgt.ovrInter,
                  protect: ovrAgt.protect,
                  commGn: ovrAgt.commGn,
                  commPct: ovrAgt.commPct,
                  commType: ovrAgt.commType,
                  void_: ovrAgt.void_
                }
                this.items.push(convertOvrAgt)
              })
              this.loading = false
            } else {
              this.loading = false
              this.items = []
            }
          } catch (error) {
            const { data } = error
            if (data) {
              this.message(data)
              this.fieldMessage(data)
              this.loading = false
            }
          }
        } else {
          this.loading = false
          this.errorMessage('The request failed because it is trying to execute an invalid API url. - Overriding Agent List')
          this.items = []
        }
      }
    },
    doReview(data) {
      this.$emit('doReview', data.item)
    },
    doQuery(data) {
      this.$emit('doQuery', data.item)
    },
    doNew() {
      this.$emit('doNew')
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedOvrInter = data
        this.deleteOvrInter = data.ovrInter
      }
    },
    async doRemove() {
      const apiURI = this.menu.updateOvrAgtVoid
      if (apiURI) {
        this.loading = true
        const formatForm = {
          inter: this.ids.inter,
          effDate: this.ids.effDate,
          polType: this.ids.polType,
          ovrInter: this.selectedOvrInter.ovrInter,
          void_: true
        }
        try {
          const result = await this.$http.put(apiURI, formatForm)
          this.notify(result.data)
          // Reinit
          const formatForm2 = {
            inter: this.ids.inter,
            effDate: formatDisplayDateTime3(this.ids.effDate),
            polType: this.ids.polType,
            ovrInter: this.selectedOvrInter.ovrInter
          }
          this.$emit('doReview', formatForm2)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. - Delete Overriding Agent')
      }
    }
  },
  props: {
    fetchOverridingAgt: {
      type: Boolean,
      default: false
    },
    ids: {
      type: Object,
      default() {
        return {
          inter: null,
          commissionNo: null,
          effDate: null,
          polType: null,
          ovrInter: null
        }
      }
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
